<template>
  <div class="app flex flex-col h-full justify-between min-h-screen">
    <section class="app__container">
      <weiby-header
        :show-cart-button="showCartButton"
        :menu-opened="showMenu"
        @show-menu="toggleMenu()"
        @show-cart="toggleCart()"
      />
      <menu-sidebar
        v-if="isAuthenticated"
        :show="showMenu"
        @close="toggleMenu(false)"
      />
      <cart-sidebar
        v-if="showCartButton"
        :show="showCart"
        @close="toggleCart(false)"
      />

      <div class="app__content">
        <transition name="fade">
          <router-view />
        </transition>
      </div>
    </section>
    <weiby-footer />
    <div v-if="showMenu" class="overlay" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import {
  CartSidebar,
  Footer as WeibyFooter,
  Header as WeibyHeader,
  MenuSidebar,
} from '@/components';
import bus from '@/utils/bus';

export default {
  name: 'App',
  components: {
    CartSidebar,
    MenuSidebar,
    WeibyFooter,
    WeibyHeader,
  },
  data() {
    return {
      showCart: false,
      showMenu: false,
    };
  },
  computed: {
    ...mapGetters('user', [
      'isAuthenticated',
    ]),
    showCartButton() {
      return this.isAuthenticated || (!this.isAuthenticated && !!this.$route?.query?.share);
    },
  },
  created() {
    bus.$on('SHOW_CART', () => {
      this.showCart = true;
    });
  },
  watch: {
    showMenu(newVal) {
      if (newVal) {
        document.body.classList.add('show-overlay');
      } else {
        document.body.classList.remove('show-overlay');
      }
    },
  },
  methods: {
    toggleCart(show = !this.showCart) {
      this.showCart = show;
    },
    toggleMenu(show = !this.showMenu) {
      this.showMenu = show;
    },
  },
};
</script>

<style lang="scss">
html, body {
  background-color: #FFFFFF;
  font-family: 'Helvetica Neue', 'PingFang TC', Arial, '微軟正黑體';
}

body {
  &.show-overlay {
    overflow: hidden;
  }
}
</style>

<style lang="scss" scoped>
.app {
  &__content {
    transition: margin 0.3s ease;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.overlay {
  @apply fixed
    backdrop-brightness-50
    bottom-0
    flex
    h-full
    items-center
    justify-center
    left-0
    overscroll-contain
    right-0
    top-0
    w-full
    z-10;

  transition: margin 0.3s ease;
}
</style>
